<template>
  <div id="side-navi">
    <template>
      <div>
        <b-button
          v-b-toggle.main_menu
          class="menu_btn btn btn-menu"
          @mouseover="logo_show()"
          @mouseout="logo_show()"
        >
          <div class="row">
            <div class="col w-100">
              <img
                v-if="logo_hidden === 0"
                :src="this.$store.state.layout.logo"
                class="logo mr-2"
                alt="iAMc"
              />
              <i class="fas fa-angle-right"></i>
            </div>
          </div>
        </b-button>

        <b-sidebar
          id="main_menu"
          aria-labelledby="sidebar-no-header-title"
          shadow
          no-header
          backdrop
          variant="primary"
          backdrop-variant="dark"
          class="nav_font_size"
          width="280px"
        >
          <template #default="{ hide }">
            <div id="menu_wrapper" class="">
              <div class="menu_header">
                <div class="row m-0 pt-2">
                  <h4 id="sidebar-no-header-title" class="col-10 text-right">
                    <img :src="logo" class="logo_menu mr-2" alt="iAMc" />
                  </h4>
                  <div class="col-1 pointer" @click="hide()">
                    <i class="fas fa-times"></i>
                  </div>
                </div>
              </div>

              <b-nav vertical>
                <b-nav-item
                  v-for="item in menu.items"
                  :key="'a-' + item.link"
                  target="_blank"
                  class="ff"
                >
                  <div v-if="item.is_dropdown" class="">
                    <b>
                      <span v-if="item.icon != ''" class="pr-2"><i :class="item.icon"/></span>
                      <span v-html="item.label"></span>
                    </b>

                    <div
                      v-for="dd in item.items"
                      :key="'dd-' + dd.link"
                      :class="dd.class"
                    >
                      <a :href="dd.link" class="pl-3 menu_dd" @click.prevent="gotoLink(dd.link, dd.target ?? '_self')">
                        <span v-if="dd.icon != ''" class="pr-2"><i :class="dd.icon"/></span>
                        <span v-html="dd.label"></span>
                      </a>
                    </div>
                  </div>
                  <div v-else>
                    <a :href="item.link" @click="gotoLink(item.link, item.target ?? '_self')">
                      <span v-if="item.icon != ''" class="pr-2"><i :class="item.icon"/></span>
                      <span v-html="item.label"></span>
                    </a>
                  </div>
                </b-nav-item>

                <b-nav-item>
                  <div class="d-md-none" v-if="deferredPwaPrompt">
                    <button class="btn pl-0 ml-0 text-white install-pwa-button" @click="installPWA()">
                      <i class="fas fa-external-link-alt"></i>
                      Add to homescreen
                    </button>
                  </div>
                </b-nav-item>
              </b-nav>
              <footer class="row text-center safari_only" id="menu_footer">
                <div class="col">
                  <div v-if="logged_in === 0">
                    <b-nav-item>
                      <router-link to="/login">Login <i class="fas fa-sign-in-alt"></i
                      ></router-link>
                    </b-nav-item>
                  </div>
                  <div v-else @click="logOut()" class="btn btn-text gold">
                    <small
                      ><i class="fas fa-sign-out-alt fa-2x"></i> <br />Sign Out
                    </small>
                  </div>
                </div>
                <div class="col">
                  <div v-if="logged_in === 0"></div>
                  <div v-else>
                    <div class="">
                      <a :href="profile_link" class="">
                        <div class="btn btn-text gold text-center">
                          <i class="far fa-user-circle fa-2x"></i>
                          <br /><small v-text="profile_name"></small>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
            <b-button class="modalBtn" v-b-modal.modal-2>Lost? Click me!</b-button>
            <b-modal class="modal-xl" id="modal-2" title="Website Tour" size="xl" ok-only ok-title="Close">
              <div class="embed-responsive embed-responsive-16by9">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZqUaBS8_bgE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </b-modal>
          </template>
        </b-sidebar>
      </div>
    </template>

    <!-- Loading Percentage Display -->
    <progress-bar
      v-if="loading_page_percentage < 1"
      :percentage="loading_page_percentage"
    />
  </div>
</template>

<script>
import ProgressBar from "../components/ProgressBar.vue";
import * as Cookie from "@/assets/js/cookie.js";

export default {
  name: "SideNavi",
  components: {
    ProgressBar,
  },
  props: {
    profile_name: {
      type: String,
    },
  },
  data() {
    return {
      logo: this.$store.state.layout.logo,
      logo_hidden: 0,
      menu_checked: 0,
      profile_link: "/profile" /*'https://auth.iamconnected.com/profile',*/,
      session_id: this.$store.state.session_id,
      deferredPwaPrompt: null
    };
  },
  computed: {
    loading_page_percentage() {
      let percentage = this.$store.getters.loadingStatus;

      if (isNaN(percentage)) {
        percentage = 0;
      }

      return percentage;
    },
    logged_in() {
      return this.$store.getters.isLoggedIn;
    },
    menu() {
      return {
        items: this.$store.getters.menuGetItems,
      };
    },
    show_menu() {
      var val = 1;
      if (this.$route.name === "login") {
        val = 0;
      }
      return val;
    },
  },
  methods: {
    logo_show() {
      this.logo_hidden = 0;
      this.logo_hide();
    },

    logo_hide() {
      let _this = this;
      var hide_logo = setInterval(function() {
        _this.logo_hidden = 1;
        console.log("setTimeOut");
        clearInterval(hide_logo);
      }, 3000);
    },

    menu_check_routes() {
      console.log("menu_check_routes");
      const categories = Object.entries(this.menu.items.dashboards.items);

      if (typeof this.menu.items.dashboards === "undefined") {
        for (const [id, elm] of categories) {
          console.log(id);
          if (typeof elm.check_route !== "undefined" && elm.check_route === 1) {
            if (!this.hasActiveRoute(elm.link)) {
              this.menu.items.dashboards.items[id].class = "hide";
            }
          }
        }
        this.menu_checked = 1;
      }
    },

    logOut() {
      let vars = {
        profile: {
          status: 0,
        },
      };

      this.$store.commit("profileSet", vars);
      this.$store.commit("menuSet", { menu: { items: null } });

      let cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        Cookie.deleteCookie(
          cookies[i].split("=")[0],
          process.env.VUE_APP_DOMAIN
        );
      }

      this.$router.push("/login");
    },
    async installPWA() {
      if (this.deferredPwaPrompt) {
        this.deferredPwaPrompt.prompt();
        const { outcome } = await this.deferredPwaPrompt.userChoice;
        if (outcome === 'accepted') {
          console.log('User accepted the PWA installation');
        } else {
          console.log('User dismissed the PWA installation');
        }
        this.deferredPwaPrompt = null
      }
    },
    gotoLink(link, target) {
      window.open(link, target)
    }
  },
  mounted() {
    this.logo_hide();

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPwaPrompt = e
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
#side-navi {
  #menu_wrapper {
    padding-top: 0;
    background-color: #d1af60 !important;
    overflow-x: hidden;
  }

  .menu_header {
    background-color: #fff !important;
  }

  .menu_btn {
    position: fixed;
    left: 0;
    z-index: 10;
  }

  .logo {
    max-height: 20px;
  }

  .logo_menu {
    max-height: 40px;
  }

  .btn-menu {
    color: #d1af60 !important;
    background-color: #fff !important;
    border: 1px solid #d1af60 !important;
  }

  .btn-menu:hover {
    color: #866f3b !important;
    background-color: #fff !important;
    border: 2px solid #d1af60 !important;
  }

  #main_menu {
    color: #fff !important;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    height: 100vh;
    overflow-y: scroll;
  }

  #main_menu a {
    color: #fff !important;
  }

  #menu_footer a {
    color: #d1af60 !important;
  }

  #main_menu .menu_dd:hover,
  #main_menu .menu_dd:focus {
    color: #fff !important;
    background-color: #d1af60 !important;
    font-weight: bold !important;
    text-decoration: none !important;
  }

  #main_menu .b-sidebar-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    overflow-y: scroll;
  }

  #menu_footer {
    background: white;
    margin-top: 1rem;
  }

  .modal-xl {
	  width: 1000px;
  }

  .modalBtn {
    margin: 30px;
  }

  // Target Safari browsers only
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (max-width: 600px) {
    #menu_footer.safari_only {
      margin-bottom: 5rem;
      padding-bottom: env(safe-area-inset-bottom);
    }
  }

  @media only screen and (max-width: 600px) {
    .nav_font_size, .install-pwa-button {
      font-size: 1.3rem;
      line-height: 2.5rem;
    }
  }
}
</style>
